import React from "react";

const Services: React.FC = () => {
  return (
    <div>
      <h1>Services</h1>
      <ul>
        <li>Advanced Audio Production</li>
        <li>Sample Melodies</li>
        <li>Digital Audio Workstation Expertise</li>
        <li>And more...</li>
      </ul>
    </div>
  );
}

export default Services;
